import {FormikErrors} from 'formik';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';

export const annuityValidator = (
  values: recommendFieldsType,
  errors: FormikErrors<recommendFieldsType>
): FormikErrors<recommendFieldsType> => {
  if (!values.annuity?.sourceId) {
    errors.annuity = 'Please select a source';
  }
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const annuityValues = values.annuity;
  if (!annuityValues) {
    errors.annuity = 'Fill in fields';
    return errors;
  }

  return errors;
};
